import { Button, InputGroup } from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import { SimpleCodeInputGroupProps } from './props'

/**
 * Simple Code Input Group
 * Normally used in Klippe Code or Promo Code validator.
 */
const SimpleCodeInputGroup = ({
    codeInputHandler,
    ctaHandler,
}: SimpleCodeInputGroupProps): ReactElement => {
    const {
        code,
        onChangeCode,
        helperText,
        isInputFieldDisabled,
        isError,
        placeholder,
        onBlur,
        dataCy,
    } = codeInputHandler
    const { isButtonDisabled, onClickButton, buttonText } = ctaHandler
    return (
        <>
            <InputGroup
                data-cy={dataCy}
                onChange={onChangeCode}
                placeholder={placeholder}
                type="text"
                value={code}
                helperText={helperText}
                disabled={isInputFieldDisabled}
                error={isError}
                onBlur={onBlur}
            />
            <Button onClick={onClickButton} disabled={isButtonDisabled}>
                {buttonText}
            </Button>
        </>
    )
}

export default SimpleCodeInputGroup
